<template>
  <v-container fluid
               class="pa-0"
  >
    <v-row align="center"
           justify="space-between"
           class="mb-4 mt-2"
    >
      <v-col cols="12"
             sm="7"
             md="5"
             lg="4"
      >
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Buscar credencial..."
          single-line
          hide-details
          outlined
          dense
          clearable
        />
      </v-col>
      <v-col cols="12"
             sm="5"
             md="4"
             class="d-flex justify-start justify-sm-end mt-2 mt-sm-0"
      >
        <v-btn color="primary"
               class="rounded-pill px-4"
               @click="openDialog"
        >
          <v-icon left>
            mdi-key-plus
          </v-icon>
          Nova Credencial
        </v-btn>
      </v-col>
    </v-row>

    <v-data-table
      :headers="headers"
      :items="credentials"
      :search="search"
      :loading="loading"
      loading-text="Carregando credenciais..."
      class="elevation-1"
    >
      <template #[`item.status`]="{ item }">
        <v-chip
          :color="item.enabled !== false ? 'success' : 'error'"
          small
          label
        >
          {{ item.enabled !== false ? 'Ativa' : 'Revogada' }}
        </v-chip>
      </template>
      <template #[`item.createdAt`]="{ item }">
        {{ formatDate(item.createdAt) }}
      </template>
      <template #[`item.actions`]="{ item }">
        <v-tooltip v-if="item.enabled !== false"
                   top
        >
          <template #activator="{ on, attrs }">
            <v-btn
              icon
              x-small
              color="primary"
              class="mr-2"
              v-bind="attrs"
              v-on="on"
              @click="editCustomers(item)"
            >
              <v-icon small>
                mdi-account-multiple-plus
              </v-icon>
            </v-btn>
          </template>
          <span>Editar Clientes</span>
        </v-tooltip>

        <v-tooltip v-if="item.enabled !== false"
                   top
        >
          <template #activator="{ on, attrs }">
            <v-btn
              icon
              x-small
              color="error"
              v-bind="attrs"
              v-on="on"
              @click="revokeCredential(item)"
            >
              <v-icon small>
                mdi-cancel
              </v-icon>
            </v-btn>
          </template>
          <span>Revogar Acesso</span>
        </v-tooltip>
      </template>
    </v-data-table>

    <create-credential-dialog ref="createDialog"
                              @created="fetchData"
    />
    <edit-credential-customers-dialog ref="editCustomersDialog"
                                      @updated="fetchData"
    />
  </v-container>
</template>

<script>
  import { $k } from '@/lib/kraken'
  import CreateCredentialDialog from './CreateCredentialDialog.vue'
  import EditCredentialCustomersDialog from './EditCredentialCustomersDialog.vue'

  export default {
    name: 'LegacyCredentialsList',
    components: { CreateCredentialDialog, EditCredentialCustomersDialog },
    data: () => ({
      loading: false,
      search: '',
      credentials: [],
      headers: [
        { text: 'Nome / Descrição', value: 'name' },
        { text: 'Client ID', value: 'username' },
        { text: 'Status', value: 'status' },
        { text: 'Criado em', value: 'createdAt' },
        { text: 'Ações', value: 'actions', sortable: false, align: 'right' },
      ],
    }),
    created() {
      this.fetchData()
    },
    methods: {
      formatDate(dateString) {
        if (!dateString) return '-'
        const date = new Date(dateString)
        return date.toLocaleDateString('pt-BR', {
          day: '2-digit', month: '2-digit', year: 'numeric',
          hour: '2-digit', minute: '2-digit',
        })
      },
      async fetchData() {
        this.loading = true
        try {
          const res = await $k.manage.users.get({
            accountRule: 'Integration',
            limit: 100,
            expanded: true,
          })
          this.credentials = res.results || res.result || res || []
        } catch (error) {
          console.error(error)
          if (this.$alert) this.$alert('error', 'Erro ao carregar credenciais')
        } finally {
          this.loading = false
        }
      },
      openDialog() {
        this.$refs.createDialog.openDialog()
      },
      editCustomers(item) {
        this.$refs.editCustomersDialog.openDialog(item)
      },
      async revokeCredential(item) {
        if (confirm(`Tem certeza que deseja revogar o acesso da credencial "${item.name}"? Esta ação não pode ser desfeita e interromperá a integração imediatamente.`)) {
          try {
            await $k.manage.users._id.put({
              id: item._id,
              enabled: false,
            })
            if (this.$alert) this.$alert('success', 'Credencial revogada com sucesso')
            this.fetchData()
          } catch (error) {
            console.error(error)
            if (this.$alert) this.$alert('error', 'Erro ao revogar credencial')
          }
        }
      },
    },
  }
</script>

<style scoped>
.v-btn.rounded-pill {
  border-radius: 50px !important;
  text-transform: none !important;
  font-weight: 600;
}
</style>
